const additionalDriverInfo = {
    name: "Segundo conductor",
    text: "Comparte la experiencia con quien tú desees.",
};

export const showAdditionalDriverInfo = (option) => {
    if (!option) return;
    return additionalDriverInfo[`${option}`];
};
